import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import AppNavbar from "./componets/Navbar.jsx";
// import Footer from "./componets/Footer";
import AdminDashboard from "./pages/Admin/AdminDashboard.jsx";
// Lazy loading the components (Better for performance)
const Home = lazy(() => import("./pages/Home.jsx"));
const Contact = lazy(() => import("./pages/Contact"));
const AboutPage = lazy(() => import("./pages/AboutPage.jsx"));
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const ProjectsPage = lazy(() => import("./pages/ProjectsPage"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const CareersPage = lazy(() => import("./pages/CareersPage"));

// --- Simple Loading Spinner Component ---
const LoadingSpinner = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height: "60vh" }}
  >
    <div
      className="spinner-border text-primary"
      role="status"
      style={{ width: "3rem", height: "3rem" }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

// Standardized Page Wrapper
const PageLayout = ({ children, title }) => (
  <div className="container py-5 mt-5">
    <h1 className="fw-bold" style={{ marginTop: "3%", color: "#0062A0" }}>
      {title}
    </h1>
    <hr
      style={{
        width: "50px",
        height: "3px",
        backgroundColor: "#E91E63",
        border: "none",
        opacity: 1,
      }}
    />
    {children}
  </div>
);

// --- Wrap Lazy Components ---
const About = () => (
  <PageLayout title="About Us">
    <AboutPage />
  </PageLayout>
);
const Services = () => (
  <PageLayout title="Our Services">
    <ServicesPage />
  </PageLayout>
);
const Projects = () => (
  <PageLayout title="Our Projects">
    <ProjectsPage />
  </PageLayout>
);
const Gallery = () => (
  <PageLayout title="Gallery">
    <GalleryPage />
  </PageLayout>
);
const Careers = () => (
  <PageLayout title="Careers">
    <CareersPage />
  </PageLayout>
);
const Admin = () => (
  <PageLayout title="AdminDashboard">
    <AdminDashboard />
  </PageLayout>
);

function App() {
  return (
    <Router>
      {/* <AppNavbar /> */}
      <main
        style={
          {
            //marginTop: "80px"
          }
        }
      >
        {/* Suspense shows the fallback (spinner) until the route component loads */}
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/AdminDashboard" element={<Admin />} />
          </Routes>
        </Suspense>
      </main>
      {/* <Footer /> */}
    </Router>
  );
}

export default App;
